import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import {
  AddNoteResponse,
  CreateNoteRequest,
  GetNoteCountsResponse,
  GetNotesResponse,
  NoteMessageResponse,
  UpdateNoteRequest,
} from '../../models/note.model';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  private readonly apiUrl = environment.backendApiConfiguration.api_url + 'notes/';

  constructor(private readonly http: HttpClient) {}

  /** GET notes/{filterGuid}/groups/{groupId} */
  getNotes(filterGuid: string, groupId: string): Observable<GetNotesResponse> {
    return this.http.get<GetNotesResponse>(
      `${this.apiUrl}${encodeURIComponent(filterGuid)}/groups/${encodeURIComponent(groupId)}`,
    );
  }

  /** GET notes/{filterGuid}/counts */
  getNoteCounts(filterGuid: string): Observable<GetNoteCountsResponse> {
    return this.http.get<GetNoteCountsResponse>(
      `${this.apiUrl}${encodeURIComponent(filterGuid)}/counts`,
    );
  }

  /** POST notes/{filterGuid}/groups/{groupId} */
  addNote(filterGuid: string, groupId: string, content: string): Observable<AddNoteResponse> {
    const body: CreateNoteRequest = { content };
    return this.http.post<AddNoteResponse>(
      `${this.apiUrl}${encodeURIComponent(filterGuid)}/groups/${encodeURIComponent(groupId)}`,
      body,
    );
  }

  /** PUT notes/{noteGuid} */
  updateNote(noteGuid: string, content: string): Observable<NoteMessageResponse> {
    const body: UpdateNoteRequest = { content };
    return this.http.put<NoteMessageResponse>(
      `${this.apiUrl}${encodeURIComponent(noteGuid)}`,
      body,
    );
  }

  /** DELETE notes/{noteGuid} */
  deleteNote(noteGuid: string): Observable<NoteMessageResponse> {
    return this.http.delete<NoteMessageResponse>(
      `${this.apiUrl}${encodeURIComponent(noteGuid)}`,
    );
  }

  /** DELETE notes/{filterGuid}/groups/{groupId} — deletes all notes of a group */
  deleteGroupNotes(filterGuid: string, groupId: string): Observable<NoteMessageResponse> {
    return this.http.delete<NoteMessageResponse>(
      `${this.apiUrl}${encodeURIComponent(filterGuid)}/groups/${encodeURIComponent(groupId)}`,
    );
  }
}
